import { render, staticRenderFns } from "./app-page-sidebar.vue?vue&type=template&id=7b7908de&scoped=true&"
import script from "./app-page-sidebar.vue?vue&type=script&lang=js&"
export * from "./app-page-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./app-page-sidebar.vue?vue&type=style&index=0&id=7b7908de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7908de",
  null
  
)

export default component.exports